module.exports = "<svg viewBox=\"0 0 106.745 106.745\"><path fill=\"#12d86f\" d=\"M46.3 46.3L92.6-.003l14.143 14.142L60.442 60.44z\"></path><path fill=\"#12d86f\" d=\"M0 14.143L14.142 0l46.301 46.3-14.142 14.143z\"></path><path fill=\"#12d86f\" d=\"M61.709 75.853L75.852 61.71l30.892 30.892L92.6 106.744z\"></path><path fill=\"#12d86f\" d=\"M0 92.601l46.3-46.3 14.143 14.142-46.301 46.301z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/close.svg
// module id = 278
// module chunks = 1